var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad-wrap"},[(_vm.show)?_c('div',{ref:"placementEl",class:_vm.classes}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }